import { Injectable } from '@angular/core';

import { AuthenticationService } from "@services/authentication/authentication.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {

  constructor(private authService: AuthenticationService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.isAuthenticated() && !this.authService.isExpiredToken()) {
      return true
    }
    this.router.navigate(['/']);
    return false;
  };
}
